export default "__VITE_ASSET__vSgJSHhy__"